import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

export interface FilterPreset {
  guid: string;
  title: string;
  filters_json: string;
  is_firm_wide?: boolean;
  created_by_guid?: string;
  created_date?: string;
}

// Firm-shared, named presets of a PrimeNG table's column-filter state (table.filters, serialized as-is
// to JSON) - table_key ('projects', 'tasks', ...) scopes the preset list to the table it was saved from.
// See FilterPresets.cs on the backend (table_filter_presets) for the storage/authorization side -
// deleting a preset is only allowed for its creator or a firm admin, enforced server-side.
@Injectable({
  providedIn: 'root'
})
export class FilterPresetsService {

  constructor(private apiService: ApiService) { }

  async List(table_key: string): Promise<FilterPreset[]> {
    const data: any = await this.apiService.get(`filter_presets/${table_key}`);
    return data?.success ? (data.data || []) : [];
  }

  // is_firm_wide is only honoured server-side if the requesting user is a firm admin - a non-admin
  // passing true here just gets silently coerced back to a personal preset (see FilterPresets.cs).
  async Save(table_key: string, title: string, filters: any, is_firm_wide: boolean): Promise<FilterPreset | null> {
    const data: any = await this.apiService.post(`filter_presets/${table_key}`, { title, filters_json: JSON.stringify(filters), is_firm_wide });
    if (!data?.success) return null;
    return Array.isArray(data.data) ? data.data[0] : data.data;
  }

  async Delete(table_key: string, guid: string): Promise<{ success: boolean; message?: string }> {
    const data: any = await this.apiService.delete(`filter_presets/${table_key}/${guid}`, null);
    return { success: !!data?.success, message: data?.message };
  }
}
